import { PLAYER_START, PLAYER_LOG_PROGRESS } from '../actions/playerActions';
import { TRACK_SHARE, TRACK_404 } from '../actions/trackingActions';


const trackEvent = (eventName, payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...payload,
  });
};

const eventTrackingMiddleware = store => next => action => {
  switch (action.type) {
    case PLAYER_START: {
      const { videoId, videoSlug } = store.getState().players[action.payload.uid];
      trackEvent('video-player-start', {
        video: {
          id: videoId,
          slug: videoSlug,
        },
      });
      break;
    }
    case PLAYER_LOG_PROGRESS: {
      const { videoId, videoSlug } = store.getState().players[action.payload.uid];
      trackEvent('video-player-progress', {
        video: {
          id: videoId,
          slug: videoSlug,
          progress: action.payload.percent,
        },
      });
      break;
    }
    case TRACK_SHARE: {
      const { url, sharedVia } = action.payload;
      trackEvent('content-share', {
        share: { url, sharedVia },
      });
      break;
    }
    case TRACK_404: {
      const { path } = action.payload;
      trackEvent('error-404', {
        error: { path },
      });
      break;
    }
    default:
      break;
  }

  next(action);
};

export default eventTrackingMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/eventTrackingMiddleware.js